import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { IconButton } from '@design-system/components/button/iconButton';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router';
import { sprinkles } from '@design-system/sprinkles.css';
import {
  Pill,
  PillProps,
} from '@client/new/pages/promotions/view/components/Pill';
import { PropsWithChildren } from 'react';

export type Breadcrumb = { name: string; url?: string };
type TitledPageHeaderProps = {
  breadcrumbs: Array<Breadcrumb>;
};

export const Breadcrumbs = (p: TitledPageHeaderProps) => {
  const data = p.breadcrumbs.reduce(
    (acc, b, i) => [
      ...acc,
      b,
      ...(i < p.breadcrumbs.length - 1 ? [{ name: '/' }] : []),
    ],
    [] as Array<Breadcrumb>,
  );
  return (
    <Typography variant="bodyLarge" style={{ fontWeight: 500 }}>
      <Row className={sprinkles({ marginBottom: 'xl' })}>
        {data.map((b, i) =>
          b.url ? (
            <Link style={{ color: '#9E9E9E' }} to={b.url} key={i}>
              {b.name}
            </Link>
          ) : (
            <span key={i}>{b.name}</span>
          ),
        )}
      </Row>
    </Typography>
  );
};
